<script>
  import { dataProvince as data } from './stores/data-province.store.js';
  import Grafico from './grafico/Grafico.svelte';
  import Switch from './util/Switch.svelte';
  export let provincia;
  export let puntuale = false;

  export let source = { url: "https://raw.githubusercontent.com/pcm-dpc/COVID-19/master/dati-province/dpc-covid19-ita-province.csv", desc: "pcm-dpc"}

  $: points = $data
    .filter(entry => entry.denominazione_provincia === provincia)
    .map(entry => {
      return {
        x: new Date(entry.data).getTime(),
        y: [{ key: 'casi', value: entry.totale_casi, color: 'white' }]
      };
    });

  $: points2 = $data
    .filter(entry => entry.denominazione_provincia === provincia)
    .map((entry, i, array) => {
      return {
        x: new Date(entry.data).getTime(),
        y: [
          {
            key: 'casi',
            value: i > 0 ? Math.max(
                    0,array[i].totale_casi - array[i - 1].totale_casi) : 0,
            color: 'white'
          }
        ]
      };
    });
</script>

<div class="bg-gray-200 rounded-lg p-4 pt-8">
  <div class="flex flex-wrap items-center mb-4 bg-gray-200 p-2 rounded-lg ">
    <div class="w-full md:w-3/4 h-12 text-blue-600 font-bold text-lg">{provincia}</div>
    <div class="w-full md:w-1/4 h-12">
      <Switch bind:checked={puntuale} label={'puntuale'} textColor={'text-blue-600'} />
    </div>
  </div>
  {#if !puntuale}
    <Grafico bind:points {source} />
  {:else}
    <Grafico bind:points={points2} {source}  />
  {/if}
</div>
